<template>
  <div class="azure-dev-ops-summary">
    <div class="_item">
      <div class="_label">
        {{ $t('azureDevOpsSummary.organization') }}:
      </div>
      <div class="_content">
        {{ query.organizationName }}
      </div>
    </div>
    <div class="_item">
      <div class="_label">
        {{ $t('azureDevOpsSummary.project') }}:
      </div>
      <div class="_content">
        <m-link
          :href="query.projectUrl"
          target="_blank"
          class="_link"
          underline-on-hover
          :disabled="query.projectUrl === '' || isPrivateDataSource"
        >
          <span class="_text">
            {{ query.projectName }}
          </span>
          <m-icon
            v-if="!(query.projectUrl === '' || isPrivateDataSource)"
            type="external-link"
          />
        </m-link>
      </div>
    </div>
    <div class="_item">
      <div class="_label">
        {{ $t('azureDevOpsSummary.filter') }}:
      </div>
      <div class="_content">
        {{ $t(`azureDevOps.filterMode.${camelCase(query.filterMode)}.shortDescription`) }}
      </div>
    </div>
    <template v-if="query.filterMode === azureDevOpsFilterMode.sharedQueries">
      <div class="_item">
        <div class="_label">
          ⮑ {{ $t('azureDevOpsSummary.sharedQueries') }}:
        </div>
        <div class="_content">
          <m-link
            :href="query.sharedQueryUrl"
            target="_blank"
            class="_link"
            underline-on-hover
            :disabled="query.sharedQueryUrl === '' || isPrivateDataSource"
          >
            <span class="_text">
              {{ query.sharedQueryName }}
            </span>
            <m-icon
              v-if="!(query.sharedQueryUrl === '' || isPrivateDataSource)"
              type="external-link"
            />
          </m-link>
        </div>
      </div>
    </template>
    <template v-if="query.filterMode === azureDevOpsFilterMode.workItems">
      <div
        v-if="query.filterWorkItemNames.length === 0"
        class="_item"
      >
        <div class="_label">
          ⮑ {{ $t('azureDevOpsSummary.filterWorkItemType') }}:
        </div>
        <div class="_content">
          {{ query.filterWorkItemType }}
        </div>
      </div>
      <div
        v-else
        class="_item"
      >
        <div class="_label">
          ⮑ {{ $t('azureDevOpsSummary.filterWorkItems', query.filterWorkItemNames.length) }}:
        </div>
        <m-tooltip
          class="_content"
          placement="bottom"
          :disabled="!filterWorkItemsIsTruncated"
          :mouse-enter-delay=".5"
        >
          <template #title>
            {{ filterWorkItems }}
          </template>
          <div
            ref="filterWorkItemsRef"
            class="_content"
          >
            {{ filterWorkItems }}
          </div>
        </m-tooltip>
      </div>
    </template>
    <div class="_item">
      <div class="_label">
        {{ $t('msPlannerSummary.aggregation') }}:
      </div>
      <div class="_content">
        {{ $t(`azureDevOps.aggregationMode.${camelCase(query.aggregationMode)}.shortDescription.${replaceDotsWithUnderscores(query.aggregationWorkItemFieldId)}`) }}
      </div>
    </div>
    <div
      v-if="query.aggregationWorkItemType !== null"
      class="_item"
    >
      <div class="_label">
        ⮑ {{ $t('azureDevOpsSummary.aggregationWorkItemType') }}:
      </div>
      <div class="_content">
        {{ query.aggregationWorkItemType }}
      </div>
    </div>
  </div>
</template>

<script setup>
import useElementsTruncate from 'shared/composables/element-truncate';
import { azureDevOpsFilterMode } from 'shared/constants.json';
import { camelCase } from 'lodash-es';
import { computed, ref } from 'vue';

const props = defineProps({
  query: {
    type: Object,
    required: true,
  },
});
const filterWorkItemsRef = ref(null);
const { isTruncated: filterWorkItemsIsTruncated } = useElementsTruncate([filterWorkItemsRef]);

const filterWorkItems = props.query.filterWorkItemNames.join(', ');

const isPrivateDataSource = computed(() => props.query.dataSource === null);

const replaceDotsWithUnderscores = (str) => str.replace(/\./g, '_');
</script>

<style scoped lang="scss" type="text/scss">
  .azure-dev-ops-summary {
    ._link {
      display: flex;
      color: $font-color-primary;

      ._text {
        margin-right: .4rem;
      }
    }

    ._item {
      display: flex;

      ._label {
        flex: 0 0 9.1rem;
        color: $font-color-secondary;
      }

      ._content {
        white-space: nowrap;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>
